module.exports = __webpack_public_path__ + "static/media/mic-on.5ce2865f.svg";